export default function sanitizeForFilename(text) {
  // Replace spaces with underscores and remove non-word characters
  return text?.replace(/\s+/g, '_')?.replace(/[^\w\-]/g, '');
}